// extracted by mini-css-extract-plugin
export default {"paper":"BotHistory_paper__aHIAL","pagination":"BotHistory_pagination__s00Kk"};